import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-theme"]

import "../public/fonts/stylesheet.scss";
import { useRoute } from "vue-router";
import { computed } from "vue";
import PaymentModal from "@/components/PaymentModal.vue";
import LanguageSwitcher from "@/components/base/LanguageSwitcher.vue";
import { useStore } from "vuex";
import BaseModal from "@/components/base/BaseModal.vue";
import { ModalConfigStruct } from "@/struct/ui/UIModalStruct";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const store = useStore();

const layoutComponent = computed(() => {
  return route.meta.layout || "main-layout";
});

const showPaymentModal = computed(() => {
  return store.getters.showPaymentModal;
});

const closePaymentModal = () => {
  store.dispatch("togglePaymentModal", false);
};

const brandId = computed(() => store.state.brand.operatorSource);

const modalConfig = computed<ModalConfigStruct | null>(
  () => store.state.system.activeConfig
);

const closeModal = () => store.dispatch("system/closeModal");

const handleAction = () => {
  if (modalConfig.value?.onAction) modalConfig.value.onAction();
  closeModal();
};

const handleSecondaryAction = () => {
  if (modalConfig.value?.onSecondaryAction)
    modalConfig.value.onSecondaryAction();
  closeModal();
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: "root",
    "data-theme": brandId.value
  }, [
    _createVNode(LanguageSwitcher, { "is-visible": false }),
    (_openBlock(), _createBlock(_resolveDynamicComponent(layoutComponent.value), null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })),
    (modalConfig.value)
      ? (_openBlock(), _createBlock(BaseModal, _mergeProps({ key: 0 }, modalConfig.value, {
          onClose: closeModal,
          onAction: handleAction,
          onSecondaryAction: handleSecondaryAction
        }), null, 16))
      : _createCommentVNode("", true),
    _createVNode(PaymentModal, {
      "show-modal": showPaymentModal.value,
      onClose: closePaymentModal
    }, null, 8, ["show-modal"])
  ], 8, _hoisted_1))
}
}

})